import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ecc_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("ecc_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then(r => { setUser(r.data); localStorage.setItem("ecc_user", JSON.stringify(r.data)); })
      .catch(() => { setUser(null); localStorage.removeItem("ecc_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const normalizedEmail = email.trim().toLowerCase();
    const base = process.env.REACT_APP_BACKEND_URL;
    const response = await fetch(`${base}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: normalizedEmail, password }),
    });

    let data = null;
    try { data = await response.json(); } catch {}

    if (!response.ok) {
      throw new Error(data?.detail || "Login failed");
    }

    if (!data?.token || !data?.user) {
      throw new Error("Invalid login response");
    }

    localStorage.setItem("ecc_token", data.token);
    localStorage.setItem("ecc_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const signup = async (payload) => {
    const r = await api.post("/auth/signup", payload);
    localStorage.setItem("ecc_token", r.data.token);
    localStorage.setItem("ecc_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("ecc_token");
    localStorage.removeItem("ecc_user");
    setUser(null);
    window.location.href = "/";
  };

  const refresh = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    localStorage.setItem("ecc_user", JSON.stringify(r.data));
    return r.data;
  };

  return <AuthCtx.Provider value={{ user, loading, login, signup, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
